import { render, staticRenderFns } from "./confirmDeleteDialog.vue?vue&type=template&id=557ce585"
import script from "./confirmDeleteDialog.vue?vue&type=script&lang=js"
export * from "./confirmDeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./confirmDeleteDialog.vue?vue&type=style&index=0&id=557ce585&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports